export const GEO_AR_RANGE_PRESETS_METERS = [
  250,
  500,
  1_000,
  2_000,
  5_000,
  10_000,
  25_000,
  50_000,
  100_000,
] as const;

export type GeoArManualRangeMeters = (typeof GEO_AR_RANGE_PRESETS_METERS)[number];
export type GeoArRangeMeters = GeoArManualRangeMeters | null;

export function formatGeoArRange(rangeMeters: GeoArRangeMeters) {
  if (rangeMeters === null) return "AUTO";
  if (rangeMeters < 1_000) return `${rangeMeters} m`;
  return `${rangeMeters / 1_000} km`;
}

export function normalizeGeoArRange(value: number | null | undefined): GeoArRangeMeters {
  if (value == null || !Number.isFinite(value)) return null;
  const numeric = Number(value);
  return GEO_AR_RANGE_PRESETS_METERS.reduce<GeoArManualRangeMeters>((best, candidate) =>
    Math.abs(candidate - numeric) < Math.abs(best - numeric) ? candidate : best,
  GEO_AR_RANGE_PRESETS_METERS[0]);
}

export function stepGeoArRange(current: GeoArRangeMeters, direction: -1 | 1): GeoArRangeMeters {
  if (current === null) return direction > 0 ? GEO_AR_RANGE_PRESETS_METERS[0] : null;
  const index = GEO_AR_RANGE_PRESETS_METERS.indexOf(current);
  if (index < 0) return normalizeGeoArRange(current);
  const nextIndex = Math.max(0, Math.min(GEO_AR_RANGE_PRESETS_METERS.length - 1, index + direction));
  return GEO_AR_RANGE_PRESETS_METERS[nextIndex];
}

export function isGeoArRangeAtMinimum(rangeMeters: GeoArRangeMeters) {
  return rangeMeters === GEO_AR_RANGE_PRESETS_METERS[0];
}

export function isGeoArRangeAtMaximum(rangeMeters: GeoArRangeMeters) {
  return rangeMeters === GEO_AR_RANGE_PRESETS_METERS[GEO_AR_RANGE_PRESETS_METERS.length - 1];
}
